var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms"},[_c('Header',{attrs:{"headTitle":"이용 약관","isShowBackBtn":""},on:{"clickBack":_vm.cancel}}),_c('div',{staticClass:"detail-page"},[_c('Terms')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }